<template>
    <transition appear name="fade-transition">
        <span class="display__boolean">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled">
                <app-chip v-if="hasValue" :type="colour" :text="value ? trueText : falseText" />
                <app-chip v-else-if="hasFallbackChip" :type="colour" :text="fallback" />
                <span v-else>{{ displayValue }}</span>
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';
import i18n from '@/lib/i18n';

export default {
    name: 'DisplayBoolean',
    extends: Display,
    props: {
        trueText: {
            type: String,
            default: i18n.t('yes')
        },
        falseText: {
            type: String,
            default: i18n.t('no')
        },
        trueColour: {
            type: String,
            default: 'success'
        },
        falseColour: {
            type: String,
            default: 'error'
        },
        fallbackColour: {
            type: String,
            default: null
        }
    },
    computed: {
        hasValue() {
            return !this._.isNil(this.value);
        },
        hasFallbackChip() {
            return !this._.isNil(this.fallback) && this.fallbackColour;
        },
        colour() {
            if (this.hasValue) {
                return this.value ? this.trueColour : this.falseColour;
            }

            return this.fallbackColour || null;
        },
        displayValue() {
            if (this.hasValue && this.fallback) {
                return this.fallback;
            }
            return this.value;
        }
    }
};
</script>
